import { Link } from 'react-router-dom';

interface MangaCardProps {
  id: string;
  slug: string;
  title: string;
  coverImage: string;
  status: string;
  category: string;
  rating: number;
  updatedAt: string;
  rank?: number;
  chapterCount?: number;
}

export default function MangaCard({ slug, title, coverImage, status, category, rating, updatedAt, rank, chapterCount }: MangaCardProps) {
  return (
    <Link
      to={`/manga/${slug}`}
      className="group block cursor-pointer"
      aria-label={`${title} - ${category}漫画`}
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={coverImage}
          alt={`${title}漫画封面`}
          title={`${title} - 免费在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {rank && (
          <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold">
            {rank}
          </div>
        )}
        <div className="absolute top-2 right-2">
          <span className={`inline-block px-2 py-0.5 text-xs rounded-full ${
            status === '连载中'
              ? 'bg-accent-500 text-background-50'
              : 'bg-foreground-600 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent p-3 pt-8">
          <div className="flex items-center gap-2">
            <span className="text-xs text-white/90 bg-white/20 px-2 py-0.5 rounded-full">
              {category}
            </span>
            {chapterCount && (
              <span className="text-xs text-white/80">
                {chapterCount}话
              </span>
            )}
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 font-heading">
        {title}
      </h3>
      <div className="flex items-center justify-between mt-1">
        <div className="flex items-center gap-1">
          <span className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-star-fill text-[10px] text-primary-400"></i>
          </span>
          <span className="text-xs text-foreground-600">{rating}</span>
        </div>
        <span className="text-xs text-foreground-500">{updatedAt}</span>
      </div>
    </Link>
  );
}